import { render, staticRenderFns } from "./TotalAll.vue?vue&type=template&id=1420a45d&scoped=true"
import script from "./TotalAll.vue?vue&type=script&lang=js"
export * from "./TotalAll.vue?vue&type=script&lang=js"
import style0 from "./TotalAll.vue?vue&type=style&index=0&id=1420a45d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1420a45d",
  null
  
)

export default component.exports